<template>
<div>
    <div class="inner-header ">
        <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
            <a @click="$router.go(-1)" class="back-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                    <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                        <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2" />
                        <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                    </g>
                </svg>
            </a>
            <a href="javascript:void(0);" class="link-title">New Meeting</a>
            <router-link :to="{ name: 'Help', params: {  name: 'Campaigns' }}" class="help-btn1">How To Add<img src="@/assets/play.svg" class="ml-1" alt=""></router-link>
        </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card">
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-12">
                                    <span class="lead-heading mt-4 mb-4">Enter Meeting Details</span>
                                </div>
                                <div class="col-12">
                                    <b-form @submit.prevent="CreateMeeting">
                                        <b-form-group>
                                            <label>Start Date And Time<span class="text-danger">*</span></label>
                                            <datetime type="datetime" v-model="AddMeeting.start_date" @input="setEndDate(AddMeeting.start_date_time)" placeholder="Start Date And Time" required></datetime>
                                        </b-form-group>
                                        <b-form-group>
                                            <label>End Date And Time<span class="text-danger">*</span></label>
                                            <datetime type="datetime" v-model="AddMeeting.end_date" placeholder="End Date And Time" required></datetime>
                                        </b-form-group>
                                        <b-form-group label="">
                                            <label>Meeting Type</label>
                                            <b-form-select v-model="AddMeeting.meeting_type" :options="meetingTypesList"></b-form-select>
                                        </b-form-group>
                                        <b-form-group label="">
                                            <label>Minutes of meeting<span class="text-danger">*</span></label>
                                            <b-form-textarea placeholder="Add minutes of meeting " required v-model="AddMeeting.minutes_of_meeting" rows="3" max-rows="6"></b-form-textarea>
                                        </b-form-group>
                                        <b-form-group label="">
                                                <CanmeraImageCapture ref="cameraCapture"/>
                                        </b-form-group>
                                        <b-form-group>
                                            <label>My Location<span class="text-danger">*</span></label>
                                            <b-form-input type="text" v-model="AddMeeting.location" readonly required placeholder="Find My Location"></b-form-input>
                                        </b-form-group>
                                        <b-form-group class="mt-5">
                                            <b-button variant="primary" type="submit" block>Save</b-button>
                                        </b-form-group>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    decodeMeetingParams
} from '@/assets/scripts/utility.js';
import {
    Datetime
} from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import haversine from 'haversine-distance'

export default {
    name: 'AddNewMeeting',
    components: {
        datetime: Datetime,
        Multiselect,
        CanmeraImageCapture: () => import('@/components/Forms/CameraImageCapture.vue')
    },
    data() {
        return {
            Campaigns: [],
            ProjectList: [],
            showCampaignModel: false,
            brokerDistanceInKM: null,
            AddCampaign: {
                start_date: null,
                end_date: null,
                campaign_type: null,
                title: null,
                achieved: null,
                enquiries_count: null,
                building_id: null,
                compaign_data: null,
                comment: null,
                executed: false,
                _destroy: false,
                IUD: 'I'
            },
            brokerSelected: {
                id: null,
                name: 'Select Broker',
                lat: null,
                long: null
            },
            AddMeeting: {
                minutes_of_meeting: '',
                location: '',
                start_date: null,
                end_date: null,
                meeting_executive_lat: '',
                meeting_executive_long: '',
                meeting_type: ''
            },
            GetS3Discussion: [{
                    value: null,
                    text: 'Select One'
                },
                {
                    value: true,
                    text: 'Yes'
                },
                {
                    value: false,
                    text: 'No'
                }
            ],
            meetingTypesList: []
        }
    },
    created() {
        this.getUserId();
        let brokers = []
        this.$store.getters.brokersMaster.forEach(broker => {
            brokers.push({
                id: broker.value,
                name: broker.text,
                lat: broker.lat,
                long: broker.long
            })
        })
        this.brokers = brokers;
        this.updateFieldRequired();
        this.selectBroker();
        this.getCurrentPosition();
    },
    computed: {
        FieldExecutiveList() {
            return this.$store.getters.FieldExecutiveMaster;
        },
        CamapaignTypes() {
            return this.$store.getters.CampaignTypesMaster;
        },
        firmList() {
            let brokers = []
            this.$store.getters.BrokersFirmNameMaster.forEach(broker => {

                brokers.push({
                    id: broker.value,
                    name: broker.text,
                    lat: broker.lat,
                    long: broker.long
                })
            })
            return brokers;
        },
        // meetingTypesList() {
        //     console.log(this.$store.getters.MeetingTypesMaster,"meeting types");
        //     return this.$store.getters.MeetingTypesMaster;
        // }
    },
    methods: {
        getUserId() {
            this.$axios.get("/enquiries/client_meetings/settings", {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    // this.meetingTypesList = res;
                    for(var i=0;i<Object.keys(res.data.meeting_types).length;i++) {
                        this.meetingTypesList.push({"text": Object.keys(res.data.meeting_types)[i], "value":Object.keys(res.data.meeting_types)[i] })
                    }
                })
                .catch((err) => {
                   console.log(err);
                });
        },
        setEndDate(start_date) {
            this.AddMeeting.end_date = start_date
        },
        AddUpdateCampaign(row) {
            if (row === undefined) {
                this.showCampaignModel = true
                this.AddCampaign.IUD = 'I'
            } else if (row.building_id !== null) {
                this.AddCampaign = row
                this.AddCampaign.IUD = 'U'
                this.showCampaignModel = true
            }
        },
        getCurrentPosition() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.AddMeeting.meeting_executive_lat = position.coords.latitude;
                    this.AddMeeting.meeting_executive_long = position.coords.longitude;
                    this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);
                }, (error) => {
                    console.log(error);
                }, {
                    timeout: 10000,
                    enableHighAccuracy: true,
                    maximumAge: 0
                });
            } else {
                //Geolocation is not supported by this browser
                console.log('Geolocation is not supported by this browser');
            }
        },
        async getStreetAddressFrom(lat, long) {
            try {
                const {
                    data
                } = await this.$axios.get(
                    "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                    lat +
                    "," +
                    long +
                    "&key=AIzaSyCDi6loOYUz1fXzMJpqI_83UlcdPrp86Fg"
                );
                if (data.error_message) {
                    console.log(data.error_message)
                } else {
                    this.AddMeeting.location = data.results[0].formatted_address;
                }
            } catch (error) {
                console.log(error);
            }
        },
        checkAppEngagement(app_eng) {
            if (app_eng) {
                this.AddMeeting.no_app_engagement_comments = null
            } else {
                this.AddMeeting.listing_count = null
                this.AddMeeting.lead_count = null
                this.AddMeeting.requirement_count = null
            }
        },
        AddNewCampiagn(row) {
            if (row.IUD === 'I') {
                this.Campaigns.push(row)
                this.showCampaignModel = false
                this.AddCampaign = {}
            } else {
                this.showCampaignModel = false
                this.AddCampaign = {}
            }
        },
        DeleteCampaign(row) {
            this.Campaigns.splice(this.Campaigns.indexOf(row), 1)
        },
        getProjects() {
            this.ProjectList = []
            let queryP = {}
            queryP['broker_id'] = this.brokerSelected.id
            this.$axios.get(`users/meetings/projects_for_new_campaign`, {
                params: queryP
            }).then((res) => {
                res.data.projects.forEach((item, index) => {
                    this.ProjectList.push({
                        value: item.id,
                        text: item.name
                    })
                });
                this.ProjectList.unshift({
                    value: null,
                    text: 'Select Project'
                })
            });
        },
        getDistanceFromSelectedBroker() {
            if (this.AddMeeting.meeting_executive_lat && this.AddMeeting.meeting_executive_long) {
                const meetingExecutiveLatLong = {
                    latitude: this.AddMeeting.meeting_executive_lat,
                    longitude: this.AddMeeting.meeting_executive_long
                }
                const selectedBrokerLatLong = {
                    latitude: this.brokerSelected.lat,
                    longitude: this.brokerSelected.long
                }
                const distance = haversine(meetingExecutiveLatLong, selectedBrokerLatLong) / 1000.0
                this.brokerDistanceInKM = distance.toFixed(2)
            }
        },
        CreateMeeting() {
            this.AddMeeting.selfie_photo = this.$refs.cameraCapture.finalImage;
            if (!this.AddMeeting.selfie_photo) {
                this.$refs.cameraCapture.checkPhoto = true;
                return;
            } else {
                this.$refs.cameraCapture.checkPhoto = false;
            }
            // this.AddMeeting.user_id = this.$route.params.id
            let formData = new FormData();
            for(let i=0;i<Object.keys(this.AddMeeting).length>0;i++) {
                formData.set(Object.keys(this.AddMeeting)[i], this.AddMeeting[Object.keys(this.AddMeeting)[i]])
            }
            // let apiParams = this.AddMeeting;
            let url = ''
            if (this.$route.query.name === 'enquiry') {
              url = `/enquiries/client_meetings/${this.$route.params.id}/create_client_meeting`
            } else {
              url = `/enquiries/client_meetings/${this.$route.params.id}/create_p_client_meeting`
            }
            this.$axios
                .post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    this.$refs.cameraCapture.stopCameraStream();

                    swal({
                        title: "Meeting Created!",
                        icon: "success",
                    }).then(this.$router.replace('/McMeetings'));
                })
                .catch((err) => {
                    if (err.response.status === 500) {
                        swal({
                            title: "Server Error!",
                            icon: "error",
                        });
                    } else {
                        swal({
                            title: "Error",
                            text: err.response.data.message,
                            icon: "error",
                        });
                    }
                });
        },
        selectBroker() {
            if (this.brokerSelected && this.brokerSelected.id) {
                this.getProjects();
                this.getDistanceFromSelectedBroker();
            }
            this.$nextTick(() => {
                if (this.$refs.brokerselect) {
                    this.$refs.brokerselect.$el.querySelector('input').required = !this.brokerSelected || !this.brokerSelected.id;
                }
            });
        },
        updateFieldRequired() {
            this.$nextTick(() => {
                if (this.$refs.multiselect) {
                    this.$refs.multiselect.$el.querySelector('input').required = !this.AddMeeting.user_id || !this.AddMeeting.user_id.value;
                }

            });
        }
    },

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style><style scoped>
.bgcolor {
    background: #f58321;
    color: white
}

table {
    font-size: 12px;
    font-weight: 400;
}

.btn-white-small {
    padding: 4px 8px;
    background: #fff;
    border: 1px solid #dfdfdf;
    margin-right: 5px;
}
</style>
